<template>
  <!-- 项目数据统计  -->
  <div class="home-pannel concented" style="height: 100%;">
    <div class="home-pannel-title titleed">
      <span>项目数据统计</span>
      <div style="margin-left: 10px;">
        <a-select
          @change="selectChange"
          size="small"
          placeholder="请选择立项时间"
          style="width: 150px;margin-left:10px;"
          allowClear
        >
          <a-select-option
            v-for="(item, index) in queryList"
            :key="index"
            :value="item.value"
          >{{ item.label }}</a-select-option>
        </a-select>
        <!-- <queryView @select="timeSelect" /> -->
      </div>
      <!-- <a-select
        mode="tags"
        size="small"
        placeholder="请选择/多选/搜索项目名称进行查询"
        style="min-width: 300px;max-width: 1300px;margin-top:12px;margin-left: 10px;"
        v-model="projectIdsQuery"
        :allowClear="true"
        @change="handleChange"
        @blur="blurChange"
      >
        <a-select-option
          v-for="(item,index) in projectDataList"
          :key="index"
          :value="item.projectId"
        >{{ item.projectName }}</a-select-option>
      </a-select>-->
      <b style="margin-left: 20px;">项目名称查询：</b>
      <a-input
        style="margin-left: 10px; width: 200px; align-items: center;margin-top:10px;"
        v-model="subject"
        placeholder="输入项目名称"
        @pressEnter="queryClick"
      >
        <a-tooltip slot="suffix" v-if="subject">
          <a-icon type="close-circle" @click="clear" />
        </a-tooltip>
      </a-input>
      <template>
        <a-button
          icon="download"
          class="filter-item add-but"
          @click="exportClick"
          style="margin-left: 6px;background-color: rgb(250, 173, 20); color: white"
        >导出项目数据统计</a-button>
      </template>
      <!-- <a-tooltip>
        <template slot="title">
          切换
        </template>
        <a-button type="primary" shape="circle" class="changeIcon" @click="changeTanOrChart">
          <a-icon type="swap" style="fontSize:18px;paddingTop:4px;"/>
        </a-button>
      </a-tooltip>-->
    </div>
    <div style="height: 86%;">
      <!-- <div v-show="showValue === 'chart'" style="height:100%;">
        <div id="lineCharId" style="width: 96%;height: 98%;"/>
      </div>-->
      <div v-show="showValue === 'table'" class="tableView">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :loading="tableLoadding"
          :pagination="tablePagination"
          :rowKey="(record,index)=>{return index}"
          :scroll="{ y: 240, x: 1600 }"
          :rowClassName="zebraStriped"
          size="small"
          style="width:100%;"
          @change="pageChange"
          bordered
          class="tableA"
        >
          <template slot="subject" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">{{ record.subject }}</template>
              <span class="onClickStyle" @click="viewClick(record)">{{ record.subject }}</span>
            </a-tooltip>
          </template>
          <template slot="jineSlot" slot-scope="text">
            <a-tooltip placement="topLeft">
              <template
                slot="title"
              >￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</template>
              <span>￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </a-tooltip>
          </template>
          <template slot="overMoney" slot-scope="text">
            <a-tooltip placement="topLeft">
              <template
                slot="title"
              >￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</template>
              <span
                style="color:orange; font-weight: bold;"
              >￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </a-tooltip>
          </template>
          <template slot="projectProfit" slot-scope="text">
            <a-tooltip placement="topLeft">
              <template
                slot="title"
              >￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</template>
              <span
                :class="text < 0 ? 'red' : ''"
              >￥{{ parseFloat(text).toLocaleString('zh-CN', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</span>
            </a-tooltip>
          </template>
          <template slot="createTime" slot-scope="text, record">
            <span>{{record.createTime.slice(0, 10)}}</span>
          </template>
        </a-table>
      </div>
    </div>
    <click-view ref="clickViewRef" :dialog-visible="clickViewVisible" @close="clickViewClose" />
  </div>
</template>

<script>
import clickView from '@/components/view/clickView.vue'
import queryView from '../queryView.vue'
export default {
  index: 'ReceiptAndPayment',
  components: { queryView, clickView },
  data () {
    return {
      clickViewVisible: false,
      myLine: null,
      showValue: 'table',
      tableData: [],
      tableLoadding: false,
      tablePagination: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizeOptions: ['5', '10', '15', '20'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条'
        },
        showQuickJumper: true, // 是否可以快速跳转至某页
        showSizeChanger: true // 是否可以改变pageSize
      },
      columns: [
        {
          width: 150,
          title: '项目名称',
          dataIndex: 'subject',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'subject' }
        },
        {
          width: 120,
          title: '项目立项时间',
          dataIndex: 'createTime',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'createTime' }
        },
        {
          width: 120,
          title: '所属财年',
          dataIndex: 'year',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'year' }
        },
        {
          width: 120,
          title: '销售人员',
          dataIndex: 'dutyPersonName',
          align: 'left',
          ellipsis: true
        },
        {
          width: 120,
          title: '合同总金额',
          dataIndex: 'contractMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '采购总金额',
          dataIndex: 'actualMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '个人报销金额',
          dataIndex: 'dutyPersonAmount',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '部门报销金额',
          dataIndex: 'deptAmount',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '现金支付',
          dataIndex: 'festivalGiftMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '驻点人员',
          dataIndex: 'operationCost',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 130,
          title: '公司人员',
          dataIndex: 'localCost',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '开票税金',
          dataIndex: 'taxes',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '收票税金',
          dataIndex: 'staxes',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '费用总金额',
          dataIndex: 'totalCost',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' },
          filterDropdown: (<span></span>),
          filterIcon: <a-tooltip placement="top" title="计算方式：采购总金额+个人报销金额+部门报销金额+现金支付+驻点人员+公司人员+开票税金"><a-icon type="info-circle" theme="twoTone" style={{ position: 'absolute', top: '12px', right: '-5px' }} /></a-tooltip>
        },
        {
          width: 120,
          title: '毛利金额',
          dataIndex: 'projectProfit',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'projectProfit' }
        },
        {
          width: 120,
          title: '回款金额',
          dataIndex: 'backMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'jineSlot' }
        },
        {
          width: 120,
          title: '逾期金额',
          dataIndex: 'overMoney',
          align: 'left',
          ellipsis: true,
          scopedSlots: { customRender: 'overMoney' }
        }

        // {
        //   title: '盈亏(元)',
        //   dataIndex: 'projectProfit',
        //   align: 'left',
        //   ellipsis: true,
        //   scopedSlots: { customRender: 'jineSlot' }
        // }
      ],
      queryList: [
        {
          label: '本月',
          value: 1
        },
        {
          label: '上月',
          value: 2
        },
        {
          label: '一季度',
          value: 3
        },
        {
          label: '二季度',
          value: 4
        },
        {
          label: '三季度',
          value: 5
        },
        {
          label: '四季度',
          value: 6
        },
        {
          label: '本年',
          value: 7
        },
        {
          label: '上年',
          value: 8
        }
      ],
      timeQueryVal: null,
      projectIdsQuery: [],
      nowTime: null,
      projectDataList: [],
      subject: '' // 项目名称查询
    }
  },
  mounted () {
    this.initData(-1)
    this.getProjectDataList()
  },
  methods: {
    clear () {
      this.subject = ''
      this.initData()
    },
    exportClick () { // 导出
      let pramsObj = {}
      pramsObj.subject = this.subject
      pramsObj.timeCondition = this.timeQueryVal
      if (this.projectIdsQuery && this.projectIdsQuery.length > 0) pramsObj.projectIds = this.projectIdsQuery.join(',')
      this.$download('/project/exportCountNew', { ...pramsObj, pageSize: -1, pageNum: -1 }, `${new Date().getTime()}项目数据统计.xlsx`)
    },
    // 通过索引的奇偶性来决定是否添加斑马纹样式
    zebraStriped (record, index) {
      // 注意：这里的index是从0开始的，所以奇数索引对应的是表格中的偶数行（视觉上）
      if (index % 2 === 1) {
        return 'zebra-striped'
      }
      return ''
    },
    timeSelect (timeVal) {
      console.log('timeVal =>', timeVal)
      this.timeQueryVal = timeVal
      // 更换查询条件
      this.getProjectDataList()
      // 刷新图表、表格
      this.projectIdsQuery = []
      if (this.showValue === 'chart') { // 刷新图表
        this.initData(-1)
      } else if (this.showValue === 'table') { // 刷新表格
        this.tablePagination.current = 1
        this.tablePagination.pageNum = 1
        this.tablePagination.pageSize = 10
        this.initData()
      }
    },
    queryClick () { // 项目名称查询
      this.initData()
    },
    initData (val) {
      this.tableLoadding = true
      let pramsObj = {}
      if (val === -1) {
        pramsObj.pageSize = -1
        pramsObj.pageNum = -1
      } else {
        pramsObj.pageSize = this.tablePagination.pageSize
        pramsObj.pageNum = this.tablePagination.pageNum
      }
      pramsObj.subject = this.subject
      pramsObj.timeCondition = this.timeQueryVal
      if (this.projectIdsQuery && this.projectIdsQuery.length > 0) pramsObj.projectIds = this.projectIdsQuery.join(',')
      // console.log(pramsObj, 'pramsObj')
      this.$get('project/countNew', pramsObj).then(res => {
        if (res.data.status === 1) {
          let resData = res.data.data.records
          this.tableData = resData
          this.tablePagination.total = Number(res.data.data.total)
          if (val === -1 && this.showValue === 'chart') { // -1图表
            this.setLineChart()
          }
        } else {
          this.$message.warning(res.data.message)
        }
      }).finally(() => {
        setTimeout(() => {
          this.tableLoadding = false
        }, 200)
      })
    },
    getProjectDataList () {
      this.projectDataList = []
      this.$get('project/countNewProject', { timeCondition: this.timeQueryVal }).then(res => {
        if (res.data.status === 1) {
          // 作为查询条件
          let resData = res.data.data
          resData.forEach(element => {
            this.projectDataList.push({
              projectId: element.projectId,
              projectName: element.projectName
            })
          })
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    handleChange (value) {
      this.projectIdsQuery = value
    },
    selectChange (e) {
      this.timeSelect(e)
    },
    blurChange () { // 丢失焦点-开始查询
      if (this.showValue === 'chart') { // 刷新图表
        this.initData(-1)
      } else if (this.showValue === 'table') { // 刷新表格
        this.tablePagination.current = 1
        this.tablePagination.pageNum = 1
        this.tablePagination.pageSize = 10
        this.initData()
      }
    },
    viewClick (rowVal) {
      console.log('rowVal.projectId =>', rowVal)
      if (rowVal.id) {
        this.clickViewVisible = true
        this.$refs.clickViewRef.openView('project', rowVal, rowVal.id)
      }
    },
    clickViewClose () {
      this.clickViewVisible = false
    },
    changeTanOrChart () {
      if (this.showValue === 'chart') {
        this.showValue = 'table'
        this.initData()
      } else if (this.showValue === 'table') {
        this.showValue = 'chart'
        this.initData(-1)
      }
    },
    pageChange (pageVal) {
      this.tablePagination.current = pageVal.current
      this.tablePagination.pageNum = pageVal.current
      this.tablePagination.pageSize = pageVal.pageSize
      this.initData()
    },
    setLineChart () {
      let that = this
      this.myLine = this.$echarts.init(document.getElementById('lineCharId'))
      if (this.tableData && this.tableData.length < 0) {
        return
      }
      var newchartName = [] // 名称标题
      var bgHeightValue = [] // 第一根柱子背景-总金额
      var bgHeightValue2 = [] // 第二根柱子背景-总金额
      var newchartValue1 = [] // 已回款
      var newchartValue2 = [] // 总成本
      var yqValue = []
      var whkValue = []
      var ykValue = []
      this.tableData.forEach(element => {
        newchartName.push(element.projectName)
        bgHeightValue.push(element.totalMoneyHeight)
        bgHeightValue2.push(element.backMoneyHeight)
        newchartValue1.push(element.backMoneyHeight)
        newchartValue2.push(element.totalCostHeight)
        whkValue.push(element.unBackMoneyHeight)
        ykValue.push(element.profitHeight)
        yqValue.push(element.overMoneyHeight)
      })
      var barWidth = 40
      /* var dataBottom = [
        {
          name: '',
          value: '100'
        },
        {
          name: '',
          value: '100'
        },
        {
          name: '',
          value: '100'
        },
        {
          name: '',
          value: '100'
        },
        {
          name: '',
          value: '100'
        }
      ] */
      var color1 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            // 第一节下面
            offset: 0,
            color: '#1C98CD'
          },
          {
            offset: 1,

            color: 'rgba(61,187,255,.16)'
          }
        ]
      }
      var color2 = {
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        type: 'linear',
        global: false,
        colorStops: [
          {
            // 第一节下面
            offset: 0,
            color: '#E7AB47'
          },
          {
            offset: 1,
            color: 'rgba(255,164,41,.16)'
          }
        ]
      }
      const lineOption = {
        legend: {
          data: ['已回款', '总成本', '逾期金额'],
          left: 'center',
          top: 10,
          itemWidth: 16.7,
          itemHeight: 7.6,
          type: 'plain',
          textStyle: {
            fontSize: 14,
            color: '#000'
          }
        },
        // 提示框
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          },
          formatter: function (param) {
            var resultTooltip =
              "<div style='background:rgba(13,5,30,.3);border:1px solid rgba(255,255,255,.2);padding:5px 10px;border-radius:4px;'>" +
              "<div style='text-align:center;'>" +
              param[0].name +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(61,187,255,.3);border: 2px solid #3eb6f5;'></span>" +
              '<span> ' +
              param[0].seriesName +
              ': </span>' +
              '<span>' +
              parseFloat(param[0].value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
              '</span>元' +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;border:3px solid rgba(61,187,255,.3);'></span>" +
              '<span> ' +
              param[9].seriesName +
              ': </span>' +
              '<span>' +
              parseFloat(param[9].value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
              '</span>元' +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:rgba(255,164,41,.3);border: 2px solid #ffc241;'></span>" +
              '<span> ' +
              param[1].seriesName +
              ': </span>' +
              '<span >' +
              parseFloat(param[1].value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
              '</span>元' +
              '</div>' +
              "<div style='padding-top:5px;'>" +
              "<span style='display:inline-block;border-radius:4px;width:20px;height:10px;background-color:" + that.getTextOrColor(param[5].value, 0) + "'></span>" +
              '<span> ' + that.getTextOrColor(param[5].value, 1) + '：</span>' +
              '<span>' +
              parseFloat(param[5].value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
              '</span>元' +
              '</div>' +
              "<div style='padding-top:5px;display:flex;'>" +
              "<div style='position: relative;top:10px;width: 20px;height: 2px;background: #FF8384;'><div style='position: absolute;top: -4px;left: 28%;width: 10px;height: 10px;border: 2px solid #F29D39;border-radius: 50%;background: #fff;'></div> </div>" +
              "<div style='margin-left:4px;'> " +
              param[8].seriesName +
              ': </div>' +
              '<span>' +
              parseFloat(param[8].value).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) +
              '</span>元' +
              '</div>' +
              '</div>'
            return resultTooltip
          }
        },
        grid: {
          top: '20%',
          left: '2%',
          bottom: '10%',
          right: '2%',
          containLabel: true
        },
        animation: false,
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,.8)'
              }
            },
            axisLabel: {
              inside: false,
              textStyle: {
                color: '#000',
                fontWeight: 'normal',
                fontSize: 12
              },
              margin: 10, // 刻度标签与轴线之间的距离。
              formatter: function (pamams) {
                if (pamams.length > 7) {
                  return pamams.slice(0, 7) + '...'
                } else {
                  return pamams
                }
              }
            },
            data: newchartName
          },
          {
            type: 'category',
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false
            },
            splitArea: {
              show: false
            },
            splitLine: {
              show: false
            },
            data: newchartName
          }
        ],
        yAxis: [
          {
            show: true,
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#000'
              }
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255,255,255,.8)'
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,.8)'
              }
            }
          }
        ],
        'dataZoom': [{
          'show': true,
          'height': 10,
          'xAxisIndex': [
            0
          ],
          bottom: '10',
          'start': 0,
          'end': 80,
          handleIcon: 'path://M306.1,413c0,2.2-1.8,4-4,4h-59.8c-2.2,0-4-1.8-4-4V200.8c0-2.2,1.8-4,4-4h59.8c2.2,0,4,1.8,4,4V413z',
          handleSize: '110%',
          handleStyle: {
            color: '#d3dee5'

          },
          textStyle: {
            color: '#000'
          },
          borderColor: '#90979c'
        }, {
          'type': 'inside',
          'show': true,
          'height': 15,
          'start': 1,
          'end': 35
        }],
        series: [
          {
            name: '已回款',
            type: 'pictorialBar',
            symbolSize: [barWidth, 10],
            symbolOffset: ['-55%', -5],
            symbolPosition: 'end',
            z: 15,
            color: '#3eb6f5',
            zlevel: 2,
            data: newchartValue1
          },
          {
            name: '总成本',
            type: 'pictorialBar',
            symbolSize: [barWidth, 10],
            symbolOffset: ['55%', -5],
            symbolPosition: 'end',
            z: 15,
            color: '#ffc241',
            zlevel: 2,
            data: newchartValue2
          },

          {
            name: '已回款',
            type: 'bar',
            barGap: '10%',
            barWidth: barWidth,
            itemStyle: {
              color: color1,
              borderColor: color1,
              borderWidth: 1,
              borderType: 'solid'
            },
            label: {
              show: false,
              formatter: '{c}' + '元',
              position: 'left',
              color: 'rgba(119,167,255,1)',
              fontSize: 13,
              fontWeight: 'bold',
              textAlign: 'center'
            },
            zlevel: 2,
            data: newchartValue1
          },
          {
            name: '总成本',
            type: 'bar',
            barGap: '10%',
            barWidth: barWidth,
            itemStyle: {
              // color: 'rgba(255,164,41,.16)',
              color: color2,
              borderColor: color2,
              borderWidth: 1,
              borderType: 'solid'
            },
            label: {
              show: false,
              formatter: '{c}' + '元',
              position: 'right',
              color: 'rgba(255,228,59,1)',
              fontSize: 13,
              fontWeight: 'bold',
              textAlign: 'center'
            },
            zlevel: 2,
            data: newchartValue2
          },
          // 背景两根柱子
          {
            name: '总金额/柱子背景',
            type: 'bar',
            xAxisIndex: 1,
            barGap: '10%',
            zlevel: 1,
            barWidth: barWidth,
            itemStyle: {
              normal: {
                color: 'rgba(61,187,255,.16)'
              }
            },
            data: bgHeightValue
          },
          {
            name: '已回款金额/柱子背景',
            type: 'bar',
            xAxisIndex: 1,
            barGap: '10%',
            data: ykValue,
            zlevel: 1,
            barWidth: barWidth,
            itemStyle: {
              normal: {
                // color: 'rgba(82,196,26,.16)'
                color: function (params) {
                  if (params.value > 0) {
                    return 'rgba(82,196,26,0.3)'
                  } else {
                    return 'rgba(255,77,79,0.3)'
                  }
                }
              }
            }
          },
          {
            name: '已回款',
            type: 'pictorialBar',
            symbolSize: [barWidth, 10],
            symbolOffset: ['-55%', 5],
            z: 12,
            color: '#3eb6f5',
            data: newchartValue1
          },
          {
            name: '盈亏',
            type: 'pictorialBar',
            symbolSize: [barWidth, 10],
            symbolOffset: ['55%', 5],
            z: 12,
            color: '#red',
            data: ykValue
          },
          // 头
          {
            name: '总额/背景柱子',
            type: 'effectScatter',
            rippleEffect: {
              period: 1,
              scale: 5,
              brushType: 'fill'
            },
            z: 20,
            zlevel: 3,
            symbolPosition: 'end',
            symbolSize: [10, 4],
            symbolOffset: [-22, 0],
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(119,167,255,1)'
              }
            },
            data: bgHeightValue
          },
          {
            name: '已回款/背景柱子',
            type: 'effectScatter',
            rippleEffect: {
              period: 1,
              scale: 5,
              brushType: 'fill'
            },
            z: 20,
            zlevel: 2,
            symbolPosition: 'end',
            symbolSize: [10, 4],
            symbolOffset: ['22', 0],
            itemStyle: {
              normal: {
                shadowColor: 'rgba(0, 0, 0, .3)',
                shadowBlur: 5,
                shadowOffsetY: 3,
                shadowOffsetX: 0,
                color: 'rgba(255,164,41,0.5)'
              }
            },
            data: bgHeightValue2
          },
          {
            name: '逾期金额',
            type: 'line',
            symbolSize: 3,
            symbol: 'emptyCircle',
            itemStyle: {
              normal: {
                color: '#FFC130',
                barBorderRadius: '100%'
              },
              borderWidth: 0
            },
            smooth: true,
            lineStyle: {
              normal: {
                width: 2,
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: '#FF8B77' // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: '#FE6AAC' // 100% 处的颜色
                    }
                  ],
                  global: false // 缺省为 false
                }
              }
            },
            data: yqValue
          },
          {
            name: '未回款',
            type: 'pictorialBar',
            symbolSize: [barWidth, 10],
            symbolOffset: ['55%', 5],
            z: 12,
            color: '#ffc241',
            data: whkValue
          }
        ]
      }
      this.myLine.setOption(lineOption, true)
    },
    getTextOrColor (val, typeVal) {
      if (typeVal) {
        if (val > 0) {
          return '盈利'
        } else {
          return '亏损'
        }
      } else {
        if (val > 0) {
          return 'rgba(82,196,26,0.3)'
        } else {
          return 'rgba(255,77,79,0.3)'
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.changeIcon {
  position: absolute;
  right: 20px;
  top: 8px;
}
.tableView {
  width: 100%;
  height: 96%;
  padding: 6px;
}
.red {
  color: red;
}
.container {
}

.container::before {
}
// 条纹样式
/deep/ .zebra-striped {
  background-color: #f3fbff !important;
}
/deep/ .ant-input-affix-wrapper .ant-input-suffix {
  top: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/homeComponents/second/projectLineChart.vue